import { render, staticRenderFns } from "./HelpMainImg.vue?vue&type=template&id=2f95ad94&scoped=true&"
import script from "./HelpMainImg.vue?vue&type=script&lang=js&"
export * from "./HelpMainImg.vue?vue&type=script&lang=js&"
import style0 from "./HelpMainImg.vue?vue&type=style&index=0&id=2f95ad94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95ad94",
  null
  
)

export default component.exports